import axios from 'axios';
import { baseUrl } from '../../constants/constants';
import { authService } from '../../services/auth';
import Toast from '../toast';

const server = axios.create({
  // baseURL: `${baseUrl}`,
});
let refresh = false;

server.interceptors.response.use(
  resp => {
    return resp;
  },
  async error => {
    if (typeof window === 'undefined') return;
    
    // Handle CORS errors specifically
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      // Network/CORS Error
      Toast('error', 'Network error. Please check if the backend server is running.');
      return Promise.reject(error);
    }
    
    if (error.response?.status === 400) {
      Toast('error', error.response.data.message || 'Bad request');
    }
    if (error.response?.status === 409) {
      Toast('error', error.response.data.message || 'Conflict');
    }
    if (error.response?.status === 401 && !refresh) {
      refresh = true;
      const refreshToken = localStorage.getItem('userRefreshToken');
      const response = await authService.RefreshToken({ refreshToken });
      if (!response) {
        return;
      }
      if (response.status === 200) {
        const accessToken = response.data.accessToken;
        const refreshToken = response.data.refreshToken;
        localStorage.setItem('userRefreshToken', refreshToken);
        localStorage.setItem('userAccess', `Bearer ${accessToken}`);
        // Use the accessToken directly, not accessToken['token']
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        return axios(error.config);
      }
    }
    refresh = false;
    return error;
  },
);

export default server;
